import React, { useEffect, useState } from "react";
import WeaveLoader from "../common/WeaveLoader";
import { Drawer } from "../../pages/site/seo/shared";
import { getRequest } from "../../utils/axios";
import { HttpStatus, SECTION_LABEL } from "./shared";

const ApiRequestDetail = ({ hash, onClose }) => {
  const [row, setRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!hash) return;
    setLoading(true);
    getRequest(
      `/api/v1/api-requests/${hash}/`,
      (res) => {
        setRow(res.data);
        setLoading(false);
      },
      () => {
        setError("Could not load request");
        setLoading(false);
      },
    );
  }, [hash]);

  return (
    <Drawer
      title="Request"
      subtitle={row ? `${row.method} ${row.endpoint}` : ""}
      onClose={onClose}
    >
      {loading ? (
        <div className="flex justify-center py-16">
          <WeaveLoader size={48} />
        </div>
      ) : error || !row ? (
        <p className="text-sm text-theme-secondary-text">{error || "Not found"}</p>
      ) : (
        <div className="space-y-6 text-sm">
          <dl className="grid grid-cols-2 gap-4">
            <div>
              <dt className="text-xs text-theme-secondary-text">Status</dt>
              <dd className="mt-0.5"><HttpStatus code={row.status_code} /></dd>
            </div>
            <div>
              <dt className="text-xs text-theme-secondary-text">Duration</dt>
              <dd className="mt-0.5">{row.milliseconds}ms</dd>
            </div>
            <div>
              <dt className="text-xs text-theme-secondary-text">Key</dt>
              <dd className="mt-0.5 truncate">{row.token_name || row.token_hash}</dd>
            </div>
            <div>
              <dt className="text-xs text-theme-secondary-text">When</dt>
              <dd className="mt-0.5">{row.create_date ? new Date(row.create_date).toLocaleString() : "Unknown"}</dd>
            </div>
          </dl>
          {row.params && Object.keys(row.params).length > 0 && (
            <div>
              <h3 className={`mb-2 ${SECTION_LABEL}`}>Params</h3>
              <pre className="max-h-40 overflow-auto whitespace-pre-wrap break-all rounded-xl bg-theme-secondary p-3 font-mono text-xs">
                {JSON.stringify(row.params, null, 2)}
              </pre>
            </div>
          )}
          {row.response != null && (
            <div>
              <h3 className={`mb-2 ${SECTION_LABEL}`}>Response</h3>
              <pre className="max-h-[50vh] overflow-auto whitespace-pre-wrap break-all rounded-xl bg-theme-secondary p-3 font-mono text-xs">
                {JSON.stringify(row.response, null, 2)}
              </pre>
            </div>
          )}
        </div>
      )}
    </Drawer>
  );
};

export default ApiRequestDetail;
